module.exports = __webpack_public_path__ + "2bfffce6609ddbfc561f59008434c21e.pdf";